import { useWatch, useFormContext } from "react-hook-form";
import { FontStyles } from "../../constants";
import FormSubSection from "../../CommonFields/FormSubSection";
import { FormColorPicker, FormInputWithUnit, FormSelect, FormRangeSlider } from "../../../../components/FormFields";
import styles from "../Shared/CommonFields.module.css";

const VolumeDesignFooterCard = () => {
    const { control } = useFormContext();
    const defaultCta = useWatch({ control, name: "bundles_design.default_cta" });
    const showFooterKeys = !defaultCta;

    if (!showFooterKeys) {
        return null;
    }

    return (
        <div id="footer-add-to-cart">
            <FormSubSection rowLabel={"Add to Cart"} hideSeparator>
                <FormColorPicker name="bundles_design.add_to_cart_bg_color" label="Background Color" />
                <FormColorPicker name="bundles_design.add_to_cart_hover_bg_color" label="Hover Color" />
                <FormColorPicker name="bundles_design.add_to_cart_text_color" label="Text Color" />
                <FormInputWithUnit
                    name="bundles_design.add_to_cart_text_size"
                    min={0}
                    label="Size"
                    placeholder="font size"
                    unitSuffix="px"
                />
                <FormSelect
                    name="bundles_design.add_to_cart_text_style"
                    label="Style"
                    options={FontStyles}
                    placeholder="Font style"
                />
                <FormColorPicker name="bundles_design.add_to_cart_border_color" label="Border Color" />
                <FormInputWithUnit
                    name="bundles_design.add_to_cart_border_width"
                    min={0}
                    label="Border Width"
                    placeholder="border width"
                    unitSuffix="px"
                />
                <FormRangeSlider
                    name="bundles_design.add_to_cart_border_radius"
                    min={0}
                    max={100}
                    label="Border Radius"
                    suffixTemplate={(val) => `${val}px`}
                    wrapperClassName={styles.rangeSliderOverride}
                />
            </FormSubSection>
        </div>
    );
};

export default VolumeDesignFooterCard;
